/* poppins-regular - latin */
@font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    src: url('/fonts/poppins/poppins-v20-latin-regular.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/poppins/poppins-v20-latin-regular.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/poppins/poppins-v20-latin-regular.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/poppins/poppins-v20-latin-regular.woff') format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/poppins/poppins-v20-latin-regular.ttf') format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */
        url('/fonts/poppins/poppins-v20-latin-regular.svg#Poppins') format('svg'); /* Legacy iOS */
  }
  /* poppins-600 - latin */
  @font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    src: url('/fonts/poppins/poppins-v20-latin-600.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/poppins/poppins-v20-latin-600.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/poppins/poppins-v20-latin-600.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/poppins/poppins-v20-latin-600.woff') format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/poppins/poppins-v20-latin-600.ttf') format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */
        url('/fonts/poppins/poppins-v20-latin-600.svg#Poppins') format('svg'); /* Legacy iOS */
  }
  
  /* figtree-regular - latin */
  @font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Figtree';
    font-style: normal;
    font-weight: 400;
    src: url('/fonts/figtree/figtree-v6-latin-regular.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/figtree/figtree-v6-latin-regular.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/figtree/figtree-v6-latin-regular.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/figtree/figtree-v6-latin-regular.woff') format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/figtree/figtree-v6-latin-regular.ttf') format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */
        url('/fonts/figtree/figtree-v6-latin-regular.svg#Figtree') format('svg'); /* Legacy iOS */
  }
  /* figtree-600 - latin */
  @font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Figtree';
    font-style: normal;
    font-weight: 600;
    src: url('/fonts/figtree/figtree-v6-latin-600.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/figtree/figtree-v6-latin-600.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/figtree/figtree-v6-latin-600.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/figtree/figtree-v6-latin-600.woff') format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/figtree/figtree-v6-latin-600.ttf') format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */
        url('/fonts/figtree/figtree-v6-latin-600.svg#Figtree') format('svg'); /* Legacy iOS */
  }
  
  /* barlow-regular - latin */
  @font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Barlow';
    font-style: normal;
    font-weight: 400;
    src: url('/fonts/barlow/barlow-v12-latin-regular.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/barlow/barlow-v12-latin-regular.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/barlow/barlow-v12-latin-regular.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/barlow/barlow-v12-latin-regular.woff') format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/barlow/barlow-v12-latin-regular.ttf') format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */
        url('/fonts/barlow/barlow-v12-latin-regular.svg#Barlow') format('svg'); /* Legacy iOS */
  }
  /* barlow-600 - latin */
  @font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Barlow';
    font-style: normal;
    font-weight: 600;
    src: url('/fonts/barlow/barlow-v12-latin-600.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/barlow/barlow-v12-latin-600.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/barlow/barlow-v12-latin-600.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/barlow/barlow-v12-latin-600.woff') format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/barlow/barlow-v12-latin-600.ttf') format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */ url('/fonts/barlow/barlow-v12-latin-600.svg#Barlow')
        format('svg'); /* Legacy iOS */
  }
  
  /* karla-regular - latin */
  @font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    src: url('/fonts/karla/karla-v31-latin-regular.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/karla/karla-v31-latin-regular.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/karla/karla-v31-latin-regular.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/karla/karla-v31-latin-regular.woff') format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/karla/karla-v31-latin-regular.ttf') format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */
        url('/fonts/karla/karla-v31-latin-regular.svg#Karla') format('svg'); /* Legacy iOS */
  }
  /* karla-600 - latin */
  @font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Karla';
    font-style: normal;
    font-weight: 600;
    src: url('/fonts/karla/karla-v31-latin-600.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/karla/karla-v31-latin-600.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/karla/karla-v31-latin-600.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/karla/karla-v31-latin-600.woff') format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/karla/karla-v31-latin-600.ttf') format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */ url('/fonts/karla/karla-v31-latin-600.svg#Karla')
        format('svg'); /* Legacy iOS */
  }
  
  /* montserrat-regular - latin */
  @font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    src: url('/fonts/montserrat/montserrat-v29-latin-regular.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/montserrat/montserrat-v29-latin-regular.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/montserrat/montserrat-v29-latin-regular.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/montserrat/montserrat-v29-latin-regular.woff')
        format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/montserrat/montserrat-v29-latin-regular.ttf') format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */
        url('/fonts/montserrat/montserrat-v29-latin-regular.svg#Montserrat') format('svg'); /* Legacy iOS */
  }
  /* montserrat-600 - latin */
  @font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    src: url('/fonts/montserrat/montserrat-v29-latin-600.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/montserrat/montserrat-v29-latin-600.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/montserrat/montserrat-v29-latin-600.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/montserrat/montserrat-v29-latin-600.woff') format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/montserrat/montserrat-v29-latin-600.ttf') format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */
        url('/fonts/montserrat/montserrat-v29-latin-600.svg#Montserrat') format('svg'); /* Legacy iOS */
  }
  
  /* mulish-regular - latin */
  @font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    src: url('/fonts/mulish/mulish-v13-latin-regular.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/mulish/mulish-v13-latin-regular.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/mulish/mulish-v13-latin-regular.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/mulish/mulish-v13-latin-regular.woff') format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/mulish/mulish-v13-latin-regular.ttf') format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */
        url('/fonts/mulish/mulish-v13-latin-regular.svg#Mulish') format('svg'); /* Legacy iOS */
  }
  /* mulish-600 - latin */
  @font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 600;
    src: url('/fonts/mulish/mulish-v13-latin-600.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/mulish/mulish-v13-latin-600.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/mulish/mulish-v13-latin-600.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/mulish/mulish-v13-latin-600.woff') format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/mulish/mulish-v13-latin-600.ttf') format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */ url('/fonts/mulish/mulish-v13-latin-600.svg#Mulish')
        format('svg'); /* Legacy iOS */
  }
  
  /* nunito-sans-regular - latin */
  @font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 400;
    src: url('/fonts/nunito-sans/nunito-sans-v15-latin-regular.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/nunito-sans/nunito-sans-v15-latin-regular.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/nunito-sans/nunito-sans-v15-latin-regular.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/nunito-sans/nunito-sans-v15-latin-regular.woff')
        format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/nunito-sans/nunito-sans-v15-latin-regular.ttf')
        format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */
        url('/fonts/nunito-sans/nunito-sans-v15-latin-regular.svg#NunitoSans') format('svg'); /* Legacy iOS */
  }
  /* nunito-sans-600 - latin */
  @font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 600;
    src: url('/fonts/nunito-sans/nunito-sans-v15-latin-600.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/nunito-sans/nunito-sans-v15-latin-600.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/nunito-sans/nunito-sans-v15-latin-600.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/nunito-sans/nunito-sans-v15-latin-600.woff') format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/nunito-sans/nunito-sans-v15-latin-600.ttf') format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */
        url('/fonts/nunito-sans/nunito-sans-v15-latin-600.svg#NunitoSans') format('svg'); /* Legacy iOS */
  }
  
  /* rubik-regular - latin */
  @font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Rubik';
    font-style: normal;
    font-weight: 400;
    src: url('/fonts/rubik/rubik-v28-latin-regular.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/rubik/rubik-v28-latin-regular.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/rubik/rubik-v28-latin-regular.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/rubik/rubik-v28-latin-regular.woff') format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/rubik/rubik-v28-latin-regular.ttf') format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */
        url('/fonts/rubik/rubik-v28-latin-regular.svg#Rubik') format('svg'); /* Legacy iOS */
  }
  /* rubik-600 - latin */
  @font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Rubik';
    font-style: normal;
    font-weight: 600;
    src: url('/fonts/rubik/rubik-v28-latin-600.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/rubik/rubik-v28-latin-600.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/rubik/rubik-v28-latin-600.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/rubik/rubik-v28-latin-600.woff') format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/rubik/rubik-v28-latin-600.ttf') format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */ url('/fonts/rubik/rubik-v28-latin-600.svg#Rubik')
        format('svg'); /* Legacy iOS */
  }
  
  /* work-sans-regular - latin */
  @font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Work Sans';
    font-style: normal;
    font-weight: 400;
    src: url('/fonts/work-sans/work-sans-v19-latin-regular.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/work-sans/work-sans-v19-latin-regular.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/work-sans/work-sans-v19-latin-regular.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/work-sans/work-sans-v19-latin-regular.woff') format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/work-sans/work-sans-v19-latin-regular.ttf') format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */
        url('/fonts/work-sans/work-sans-v19-latin-regular.svg#WorkSans') format('svg'); /* Legacy iOS */
  }
  /* work-sans-600 - latin */
  @font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Work Sans';
    font-style: normal;
    font-weight: 600;
    src: url('/fonts/work-sans/work-sans-v19-latin-600.eot'); /* IE9 Compat Modes */
    src:
      url('/fonts/work-sans/work-sans-v19-latin-600.eot?#iefix') format('embedded-opentype'),
      /* IE6-IE8 */ url('/fonts/work-sans/work-sans-v19-latin-600.woff2') format('woff2'),
      /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */ url('/fonts/work-sans/work-sans-v19-latin-600.woff') format('woff'),
      /* Chrome 5+, Firefox 3.6+, IE 9+, Safari 5.1+, iOS 5+ */ url('/fonts/work-sans/work-sans-v19-latin-600.ttf') format('truetype'),
      /* Chrome 4+, Firefox 3.5+, IE 9+, Safari 3.1+, iOS 4.2+, Android Browser 2.2+ */
        url('/fonts/work-sans/work-sans-v19-latin-600.svg#WorkSans') format('svg'); /* Legacy iOS */
  }
  